import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container, Form, Row, Col, Button } from 'react-bootstrap';
import PageTooltip from "../components/Tooltip";
import DatePicker from "react-datepicker";
import { getPofile, pageErrors, updateProfile, storeProfile } from '../hooks/auth'
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import "react-datepicker/dist/react-datepicker.css"

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

const mapDispatchToProps = (dispatch) => ({
  getPofile: () => dispatch(getPofile()),
  pageErrors: () => dispatch(pageErrors()),
  updateProfile: (data) => dispatch(updateProfile(data)),
  storeProfile: () => dispatch(storeProfile())
})

const getValidate = (state) => {
  var first_name = null
  var last_name = null
  var date_of_birth = null
  var email = null
  var phone = null
  var valid = true

  if (state.first_name == null || state.first_name == "") {
    first_name = "Required"
    valid = false
  }
  if (state.last_name == null || state.last_name == "") {
    last_name = "Required"
    valid = false
  }
  if (state.date_of_birth == null || state.date_of_birth == "") {
    date_of_birth = "Required"
    valid = false
  }
  // if(state.phone !== null && state.phone !== "") {
  //   if(state.phone.length < 10 || !state.phone.startsWith('44')) {
  //     phone = "Not valid"
  //     valid = false
  //   }
  // }
  if (state.email == null || state.email == "") {
    email = "Required"
    valid = false
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(state.email)) {
    email = "invalid email address"
    valid = false
  }

  return { data: { first_name: first_name, last_name: last_name, email: email, phone: phone, date_of_birth: date_of_birth }, valid }
}

class Profile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      country_code: "+44",
      phone: "",
      date_of_birth: null,
      error: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        date_of_birth: null
      },
      update: true,
      two_factor_enabled: false
    }
    this.props.getPofile()
  }

  componentDidUpdate = () => {
    if (this.props.auth.profile != null) {
      var date = new Date(this.props.auth.profile.date_of_birth);
      this.props.storeProfile()
      this.setState({
        first_name: this.props.auth.profile.first_name,
        last_name: this.props.auth.profile.last_name,
        email: this.props.auth.profile.email,
        country_code: this.props.auth.profile.country_code !== null ? this.props.auth.profile.country_code.toString() : "+44",
        phone: this.props.auth.profile.phone,
        two_factor_enabled: this.props.auth.profile.two_factor_enabled,
        date_of_birth: date,
        update: true
      })
    }
  }

  handleDateChange = (date) => {
    this.setState({ date_of_birth: date, update: false })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: {
        ...this.state.error,
        [e.target.name]: null
      },
      update: false
    })
  }

  updateProfile = () => {
    const formattedDate = this.state.date_of_birth.toISOString().split("T")[0];
    if (getValidate(this.state).valid) {
      this.props.updateProfile({
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        email: this.state.email,
        country_code: this.state.country_code,
        phone: this.state.phone,
        two_factor_enabled: this.state.two_factor_enabled,
        date_of_birth: formattedDate
      })
    } else {
      this.setState({ error: getValidate(this.state).data })
    }
  }


  handleKeyDown = (event) => {
    if (
      [46, 8, 9, 27, 13, 110, 190].includes(event.keyCode) ||
      (event.keyCode === 65 && event.ctrlKey === true) ||
      (event.keyCode === 67 && event.ctrlKey === true) ||
      (event.keyCode === 86 && event.ctrlKey === true) ||
      (event.keyCode === 88 && event.ctrlKey === true) ||
      (event.keyCode >= 35 && event.keyCode <= 39)
    ) {
      return;
    }

    if (
      (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
      (event.keyCode < 96 || event.keyCode > 105)
    ) {
      event.preventDefault();
    }
  }

  handlePaste = (event) => {
    const pastedData = event.clipboardData.getData('text');
    if (!/^\d+$/.test(pastedData)) {
      event.preventDefault()
    }
  };

  handlePhoneChange = (value, countryData) => {
    const newCountryCode = `+${countryData.dialCode}`;
    this.setState({
      country_code: newCountryCode,
      phone: "",
      update: false
    })
  };

  render() {

    return (
      <Fragment>
        <NavbarComp access_token={true} />
        <div className="page-sections">
          <div className="register-wrap">
            <Container>
              <div className="register-contents">
                <h2 className="main-title-style">PROFILE</h2>
                <p>
                  These are the details we have for you. Your details are visible only to you and the Third Pillar of Health – the study lead.
                </p>
                <p>
                  The first letter of your first name and last name form your initials. We then add these to your date of birth in a DD-MM-YY
                  format to give us your username.
                </p>
                <p>
                  Your login details are XX-XX-XX-XX. When you login you use these details together with the 4-number PIN you provided us at
                  login. If you have forgotten your PIN then please make sure at least your email or (mobile) phone number is added.
                </p>
                <p>
                  We use your email and / or phone to communicate with you. You can ask us to send you notifications to remind you to add
                  some more data. We use them if you forget your PIN and we will use them if you win a prize in one of our prize draws.
                </p>
                <div className="register-form">
                  <Row>
                    <Col lg={6} md={12}>
                      <Form.Group className="mb-4" controlId="formGroupFName">
                        <Form.Label>First name*{this.state.error.first_name !== null ? <span className="error-span">{this.state.error.first_name}</span> : null}</Form.Label>
                        <Form.Control onChange={this.handleChange} value={this.state.first_name} name="first_name" type="text" placeholder="Enter first name" />
                      </Form.Group>
                    </Col>
                    <Col lg={6} md={12}>
                      <Form.Group className="mb-4" controlId="formGroupLName">
                        <Form.Label>Last name*{this.state.error.last_name !== null ? <span className="error-span">{this.state.error.last_name}</span> : null}</Form.Label>
                        <Form.Control onChange={this.handleChange} value={this.state.last_name} name="last_name" type="text" placeholder="Enter last name" />
                      </Form.Group>
                    </Col>
                    <Col lg={6} md={12}>
                      <Form.Group className="mb-4" controlId="formGroupEmail">
                        <PageTooltip
                          title="Email"
                          text="Adding an email address enables you to set reminders to complete tests at the beginning of your shift. Adding an email also makes it easier to reset your PIN if you forget it."
                          error={this.state.error.email !== null}
                          error_text={this.state.error.email}
                        />
                        <Form.Control onChange={this.handleChange} value={this.state.email} name="email" type="email" placeholder="test@test.com" />
                      </Form.Group>
                    </Col>
                    <Col lg={6} md={12}>
                      <Form.Group className="mb-4" controlId="formGroupPhone">
                        <PageTooltip
                          title="Mobile phone"
                          text="Adding a mobile phone number enables you to set reminders to complete tests at the beginning of your shift."
                          error={this.state.error.phone !== null}
                          error_text={this.state.error.phone}
                        />

                        <div className='mobile-div'>
                          <PhoneInput
                            className="country-code-mobile"
                            country={"gb"}
                            value={this.state.country_code}
                            onChange={this.handlePhoneChange}
                            disableCountryCode={false}
                            disableDropdown={false}
                            enableAreaCodes={false}
                            inputProps={{
                              readOnly: true
                            }}
                          />
                          <Form.Control className='mobile-value' onPaste={this.handlePaste} onKeyDown={this.handleKeyDown} onChange={this.handleChange} value={this.state.phone} name="phone" type="number" placeholder="Enter mobile phone number starting with 0" />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg={6} md={12}>
                      <Form.Group className="dob-field-profile" controlId="formGroupDOB">
                        <Form.Label>Date of birth*{this.state.error.date_of_birth !== null ? <span className="error-span">{this.state.error.date_of_birth}</span> : null}</Form.Label>
                        <DatePicker
                          placeholderText="XX/XX/XXXX"
                          dateFormat="dd/MM/yyyy"
                          selected={this.state.date_of_birth}
                          onChange={(date) => this.handleDateChange(date)}
                        />
                      </Form.Group>
                    </Col>
                    
                    <Col lg={12}>
                      <div key={`default-checkbox`} className="form-checkboxes">
                        <Form.Check checked={this.state.two_factor_enabled} onClick={(e) => this.setState({ two_factor_enabled: e.target.checked, update: false })} type="checkbox" id={`keep-login`} label={`Enable 2FA authentication`} />
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="form-submit-btn">
                        <Button disabled={this.state.update} onClick={this.updateProfile} type="submit">SUBMIT</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Container>
          </div>
        </div>
        <FooterComp />
      </Fragment>
    );
  }
}

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);